import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useUseCases } from "@/context/UseCasesProvider";

export const useDataOptions = () => {
  const { t } = useTranslation();
  const settingsInterface = useUseCases();

  const columns = useMemo(() => [
    { name: t("id"), uid: "jobID", sortable: true, style: { width: '120px', minWidth: '120px', maxWidth: '120px' } },
    settingsInterface?.settings?.display?.features?.entity && { name: t("entity"), uid: "entity_name", sortable: true, style: { width: '60px', minWidth: '60px', maxWidth: '60px' } },
    { name: t("status"), uid: "status", sortable: true, style: { width: '170px', minWidth: '170px', maxWidth: '170px' } },
    { name: t("delivery_date"), uid: "order_delivery_date", sortable: true, style: { width: '140px', minWidth: '140px', maxWidth: '140px' } },
    { name: t("reception_date"), uid: "start_datetime", sortable: true, style: { width: '135px', minWidth: '135px', maxWidth: '135px' } },
    { name: t("client"), uid: "customer_name", sortable: true, style: { width: '15%', minWidth: '150px' } },
    { name: t("subject"), uid: "subject", sortable: true },
    { name: t("assigned_to"), uid: "assignment", sortable: true, style: { width: '180px', minWidth: '180px', maxWidth: '180px' } },
    { name: "", uid: "order_status_indicator", sortable: false, alwaysVisible: true, style: { width: '20px', minWidth: '20px', maxWidth: '20px', paddingLeft: 0, paddingRight: 0 } },
    { name: t("to_verify"), uid: "warnings", sortable: true, style: { width: '60px', minWidth: '60px', maxWidth: '60px' } },
    { name: t("products_counter"), uid: "products_counter", sortable: true, style: { width: '60px', minWidth: '60px', maxWidth: '60px' } },
    { name: t("remaining_time"), uid: "deadline", sortable: true, style: { width: '180px', minWidth: '180px', maxWidth: '180px' } },
    { name: t("actions"), uid: "actions", style: { width: '50px', minWidth: '50px', maxWidth: '50px' } },
  ].filter(Boolean), [t, settingsInterface?.settings?.display?.features?.entity]);

  const statusOptions = useMemo(() => [
    { name: t("validated"), uid: "success" },
    { name: t("to_process"), uid: "pending_review" },
    { name: t("archived"), uid: "archive" },
    { name: t("error"), uid: "failed" },
  ], [t]);

  return { columns, statusOptions };
};